import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DEFAULT_RIBBON_STATE } from "./constants";
import { IRibbonState } from "./interfaces";
import { TActiveContent } from "~/ribbon/interfaces";

const ribbonSlice = createSlice({
	name: "ribbon",
	initialState: DEFAULT_RIBBON_STATE,
	reducers: {
		/* pro ribbon */
		setRibbonEnabled: (state: IRibbonState, action: PayloadAction<Pick<IRibbonState, "enabled" | "enabledLocation">>) => {
			state.enabled = action.payload.enabled;
			state.enabledLocation = action.payload.enabledLocation;
		},
		setRibbonInitData: (state: IRibbonState, action: PayloadAction<Pick<IRibbonState, "userVariant" | "debug" | "enabled">>) => {
			state.userVariant = action.payload.userVariant;
			state.debug = action.payload.debug;
			state.enabled = action.payload.enabled;
		},
		setRibbonMinimalized: (state: IRibbonState, action: PayloadAction<IRibbonState["minimalized"]>) => {
			state.minimalized = action.payload;
		},
		setRibbonHidden: (state: IRibbonState, action: PayloadAction<IRibbonState["hidden"]>) => {
			state.hidden = action.payload;
		},
		/* pro kontenty map */
		addActiveContent: (state: IRibbonState, action: PayloadAction<TActiveContent>) => {
			const content = action.payload;

			if (state.activeContents.indexOf(content) === -1) {
				state.activeContents.push(content);
			}
		},
		removeActiveContent: (state: IRibbonState, action: PayloadAction<TActiveContent>) => {
			const content = action.payload;
			const ind = state.activeContents.indexOf(content);

			if (ind !== -1) {
				const activeContents = state.activeContents.slice();

				activeContents.splice(ind, 1);
				state.activeContents = activeContents;
			}
		},
	},
});

export const { addActiveContent, removeActiveContent, setRibbonEnabled, setRibbonInitData, setRibbonMinimalized, setRibbonHidden } = ribbonSlice.actions;
export default ribbonSlice.reducer;
